(function () {
  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function getOriginalSlides(track) {
    return Array.prototype.slice.call(
      track.querySelectorAll(".stories-light-hour-testimonials__slide:not(.is-clone)")
    );
  }

  function setActiveDot(dots, activeIndex) {
    dots.forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle("is-active", isActive);

      if (isActive) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });
  }

  function buildLoopTrack(track) {
    if (!track || track.dataset.storiesLoopReady === "true") {
      return;
    }

    var originals = Array.prototype.slice.call(track.children);

    if (originals.length < 2) {
      track.dataset.storiesLoopReady = "true";
      return;
    }

    originals.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.classList.add("is-clone");
      clone.setAttribute("aria-hidden", "true");
      clone.removeAttribute("id");
      track.appendChild(clone);
    });

    track.dataset.storiesLoopReady = "true";
  }

  function getLoopWidth(track, originalSlides) {
    if (!track || originalSlides.length < 2) {
      return 0;
    }

    var firstClone = track.querySelector(".stories-light-hour-testimonials__slide.is-clone");

    if (!firstClone) {
      return 0;
    }

    return firstClone.offsetLeft - originalSlides[0].offsetLeft;
  }

  function normalizeScrollLeft(viewport, loopWidth) {
    if (!loopWidth) {
      return;
    }

    if (viewport.scrollLeft >= loopWidth) {
      viewport.scrollLeft -= loopWidth;
    } else if (viewport.scrollLeft < 0) {
      viewport.scrollLeft += loopWidth;
    }
  }

  function getViewportPaddingLeft(viewport) {
    return parseFloat(window.getComputedStyle(viewport).paddingLeft) || 0;
  }

  function getTargetScrollLeft(viewport, slide, loopWidth) {
    var maxOffset = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var baseOffset = slide.offsetLeft - getViewportPaddingLeft(viewport);

    if (!loopWidth) {
      return clamp(baseOffset, 0, maxOffset);
    }

    var currentOffset = viewport.scrollLeft;
    var candidates = [baseOffset, baseOffset + loopWidth, baseOffset - loopWidth];
    var targetOffset = candidates[0];
    var shortestDistance = Math.abs(candidates[0] - currentOffset);

    candidates.forEach(function (candidate) {
      var distance = Math.abs(candidate - currentOffset);

      if (distance < shortestDistance) {
        shortestDistance = distance;
        targetOffset = candidate;
      }
    });

    return clamp(targetOffset, 0, maxOffset);
  }

  function getActiveIndex(viewport, originalSlides, loopWidth) {
    if (!originalSlides.length) {
      return 0;
    }

    var normalizedScrollLeft = loopWidth
      ? ((viewport.scrollLeft % loopWidth) + loopWidth) % loopWidth
      : viewport.scrollLeft;
    var viewportCenter = normalizedScrollLeft + viewport.clientWidth / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    originalSlides.forEach(function (slide, index) {
      var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      var distance = Math.abs(slideCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function jumpToSlide(viewport, dots, originalSlides, loopWidth, index, behavior) {
    if (!originalSlides.length) {
      return 0;
    }

    var activeIndex = clamp(index, 0, originalSlides.length - 1);
    var targetSlide = originalSlides[activeIndex];
    var targetLeft = getTargetScrollLeft(viewport, targetSlide, loopWidth);

    if (behavior === "smooth") {
      viewport.scrollTo({
        left: targetLeft,
        behavior: "smooth"
      });
    } else {
      viewport.scrollLeft = targetLeft;
    }

    viewport.dataset.activeIndex = String(activeIndex);
    setActiveDot(dots, activeIndex);

    return activeIndex;
  }

  function initStoriesTestimonials(section) {
    if (!section || section.dataset.storiesTestimonialsReady === "true") {
      return;
    }

    var viewport = section.querySelector("[data-stories-viewport]");
    var track = viewport ? viewport.querySelector(".stories-light-hour-testimonials__track") : null;
    var dots = Array.prototype.slice.call(section.querySelectorAll("[data-stories-dot]"));
    var initialIndex = Number(section.getAttribute("data-initial-index") || 0);

    if (!viewport || !track) {
      section.dataset.storiesTestimonialsReady = "true";
      return;
    }

    buildLoopTrack(track);

    var originalSlides = getOriginalSlides(track);

    if (!originalSlides.length) {
      section.dataset.storiesTestimonialsReady = "true";
      return;
    }

    var loopWidth = getLoopWidth(track, originalSlides);
    var activeIndex = clamp(initialIndex, 0, originalSlides.length - 1);
    var touchStartX = 0;
    var touchDeltaX = 0;
    // Match Best Sellers Splide autoScroll speed: 0.65px/frame at ~60fps.
    var autoScrollSpeed = 39;
    var rafId = null;
    var resumeTimerId = null;
    var lastFrameTime = 0;
    var isAutoScrolling = false;

    function stopAutoScroll() {
      isAutoScrolling = false;
      lastFrameTime = 0;

      if (resumeTimerId) {
        window.clearTimeout(resumeTimerId);
        resumeTimerId = null;
      }

      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function scheduleResume(delay) {
      if (originalSlides.length < 2) {
        return;
      }

      if (resumeTimerId) {
        window.clearTimeout(resumeTimerId);
      }

      resumeTimerId = window.setTimeout(function () {
        resumeTimerId = null;
        startAutoScroll();
      }, delay);
    }

    function updateActiveDotFromScroll() {
      activeIndex = getActiveIndex(viewport, originalSlides, loopWidth);
      viewport.dataset.activeIndex = String(activeIndex);
      setActiveDot(dots, activeIndex);
    }

    function tick(timestamp) {
      if (!isAutoScrolling) {
        return;
      }

      if (!lastFrameTime) {
        lastFrameTime = timestamp;
      }

      var delta = timestamp - lastFrameTime;
      lastFrameTime = timestamp;

      viewport.scrollLeft += (autoScrollSpeed * delta) / 1000;
      normalizeScrollLeft(viewport, loopWidth);
      updateActiveDotFromScroll();
      rafId = window.requestAnimationFrame(tick);
    }

    function startAutoScroll() {
      if (originalSlides.length < 2 || isAutoScrolling || document.hidden) {
        return;
      }

      isAutoScrolling = true;
      lastFrameTime = 0;
      rafId = window.requestAnimationFrame(tick);
    }

    function refreshMetrics() {
      originalSlides = getOriginalSlides(track);
      loopWidth = getLoopWidth(track, originalSlides);
      activeIndex = jumpToSlide(viewport, dots, originalSlides, loopWidth, activeIndex, "auto");
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        stopAutoScroll();
        activeIndex = Number(dot.getAttribute("data-index"));
        activeIndex = jumpToSlide(viewport, dots, originalSlides, loopWidth, activeIndex, "smooth");
        scheduleResume(1200);
      });
    });

    viewport.addEventListener(
      "touchstart",
      function (event) {
        if (!event.touches.length) {
          return;
        }

        stopAutoScroll();
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    viewport.addEventListener(
      "touchmove",
      function (event) {
        if (!event.touches.length) {
          return;
        }

        touchDeltaX = event.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    viewport.addEventListener("touchend", function () {
      if (Math.abs(touchDeltaX) < 42) {
        scheduleResume(200);
        return;
      }

      if (touchDeltaX < 0) {
        activeIndex = clamp(activeIndex + 1, 0, originalSlides.length - 1);
      } else {
        activeIndex = clamp(activeIndex - 1, 0, originalSlides.length - 1);
      }

      activeIndex = jumpToSlide(viewport, dots, originalSlides, loopWidth, activeIndex, "smooth");
      scheduleResume(1200);
    });

    window.addEventListener("resize", refreshMetrics);

    section.addEventListener("mouseenter", stopAutoScroll);
    section.addEventListener("mouseleave", startAutoScroll);
    section.addEventListener("focusin", stopAutoScroll);
    section.addEventListener("focusout", function (event) {
      if (event.relatedTarget && section.contains(event.relatedTarget)) {
        return;
      }

      startAutoScroll();
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopAutoScroll();
      } else {
        startAutoScroll();
      }
    });

    activeIndex = jumpToSlide(viewport, dots, originalSlides, loopWidth, activeIndex, "auto");
    startAutoScroll();
    section.dataset.storiesTestimonialsReady = "true";
  }

  function initAllStoriesTestimonials() {
    document.querySelectorAll("[data-stories-testimonials]").forEach(initStoriesTestimonials);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllStoriesTestimonials);
  } else {
    initAllStoriesTestimonials();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) {
      return;
    }

    event.target.querySelectorAll("[data-stories-testimonials]").forEach(initStoriesTestimonials);
  });
})();
